module.exports = __webpack_public_path__ + "static/media/sunSet.8d5a670a.png";